function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import is from 'is';
import Handlebars from 'handlebars';
import axios from 'axios';

var TemplateManager = /*#__PURE__*/function () {
  function TemplateManager(root) {
    _classCallCheck(this, TemplateManager);

    this.base$url = root;
    this.templates = {};
  }

  _createClass(TemplateManager, [{
    key: "exist",
    value: function exist(name) {
      return !!this.templates[name];
    }
  }, {
    key: "add",
    value: function add(name, file) {
      var _this = this;

      var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.$url = "".concat(this.base$url);

      if (!name) {
        throw new Error("\"name\" no esta definido");
      }

      var path = this.$url + file + '?v=' + Date.now();
      var config = {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      };
      config['credentials'] = window.origin;
      config['crossDomain'] = true;

      if (is.object(headers)) {
        Object.assign(config.headers, headers);
      }

      return new Promise(function (resolve, reject) {
        if (is.undef(_this.templates[name])) {
          axios(path, config).then(function (response) {
            _this.templates[name] = Handlebars.compile(response.data);
            var tmp = _this.templates[name];
            resolve(tmp);
          }).catch(function (err) {
            reject(err);
          });
        }
      });
    }
  }, {
    key: "remove",
    value: function remove(name) {
      if (!is.undef(this.templates[name])) {
        delete this.templates[name];
      }
    }
  }]);

  return TemplateManager;
}();

export { TemplateManager as default };